/*
 * HEIMWEH — "Versand" im Warenkorb oeffnet das Versandkosten-Popup
 * ---------------------------------------------------------------
 * AUSGANGSLAGE
 * Unter der Gesamtsumme steht "Steuern inklusive. Versand und
 * Rabatte werden an der Kasse berechnet." Das Wort Versand ist ein
 * <a> auf die Versandrichtlinie. Der Satz selbst bleibt unveraendert,
 * nur das Ziel des Wortes aendert sich: statt Seitenwechsel oeffnet
 * es jetzt dasselbe Popup wie "zzgl. Versandkosten" auf der
 * Produktseite.
 *
 * WARUM PER JAVASCRIPT UND NICHT IM LIQUID
 * Der Satz entsteht in sections/main-cart.liquid und
 * sections/cart-drawer.liquid aus der Uebersetzung
 * sections.cart.taxes_included_and_shipping_policy_html. In
 * main-cart.liquid liegt zwar schon ein fertiges Popup samt
 * Ausloeser (Klasse ctm_shipp_cart, Modal PopupModal-price), der
 * Zweig der if-Kette wird aber nie erreicht: Zweig 1 greift, sobald
 * Preise inklusive Steuern sind UND eine Versandrichtlinie
 * hinterlegt ist — beides trifft zu. Beide Dateien sind 50 bis 60 KB
 * gross und lassen sich ueber die Shopify-API nicht teilweise
 * schreiben, deshalb diese kleine Ergaenzung statt eines Eingriffs
 * in zwei grosse Theme-Dateien.
 *
 * WAS DIE DATEI TUT
 * Sie ersetzt im Block .tax-note den Link durch ein <span> mit der
 * vorhandenen Theme-Klasse ctm_shipp_cart (Unterstreichung und
 * Hand-Cursor stehen bereits in assets/mandasa.css) und oeffnet beim
 * Klick das Modal HWVersandModal aus snippets/hw-versand-popup.liquid.
 *
 * WARUM EIN EIGENER CLICK-HANDLER
 * <basic-modal> bindet seine Ausloeser einmalig beim Einhaengen ins
 * DOM (siehe theme.js, get controls()). Ein spaeter eingefuegtes
 * Element wuerde dabei nicht beruecksichtigt. Oeffnen heisst dort
 * schlicht open-Attribut setzen, genau das macht der Handler hier.
 *
 * WARUM EIN MUTATIONOBSERVER
 * Der Warenkorb rendert sich nach jeder Mengenaenderung neu, der
 * Drawer wird nachgeladen. Ohne erneuten Durchlauf waere der Link
 * danach wieder ein Link.
 */
(function () {
  'use strict';

  var MODAL_ID = 'HWVersandModal';

  function openModal(event) {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    event.preventDefault();
    event.stopPropagation();
    modal.setAttribute('open', '');
  }

  function convert() {
    var links = document.querySelectorAll('.tax-note a');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];

      // Links INNERHALB eines Popups nicht anfassen: Auf der
      // Warenkorbseite liegt das alte Modal PopupModal-price im
      // selben .tax-note-Block, sein Inhalt kann Links enthalten.
      if (link.closest('basic-modal')) continue;

      var span = document.createElement('span');
      span.className = 'ctm_shipp_cart';
      span.setAttribute('role', 'button');
      span.setAttribute('tabindex', '0');
      span.setAttribute('aria-controls', MODAL_ID);
      span.textContent = link.textContent;
      span.addEventListener('click', openModal);
      span.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') openModal(event);
      });

      link.parentNode.replaceChild(span, link);
    }
  }

  function start() {
    convert();

    if (!window.MutationObserver) return;

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        convert();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();